module.exports = __webpack_public_path__ + "static/media/s_bar12.b239ad25.svg";